import { render, staticRenderFns } from "./WasteResultDisplay.vue?vue&type=template&id=2b542f7a&scoped=true&"
import script from "./WasteResultDisplay.vue?vue&type=script&lang=js&"
export * from "./WasteResultDisplay.vue?vue&type=script&lang=js&"
import style0 from "./WasteResultDisplay.vue?vue&type=style&index=0&id=2b542f7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b542f7a",
  null
  
)

export default component.exports